import Api from '@/services/Api'
import axios from 'axios'

export default {

    getAuditRecords() {
        return Api().get("/audit-ohs");
    },

    getAuditRecordsDate(params) {
        return Api().post("/audit-ohs-date-between",params);
    }

}


// WEBPACK FOOTER //
// ./src/services/AuditService.js